<template>
      <q-form ref="DocumentBRForm">
    <div class="card-body pb-0 pl-1 pt-0">
      <div class="row form-group">
        <div class="col-lg-4 col-md-4 col-sm-6 form-control no-border">
          <span class="d-block mb-0 small text-muted mb-2">cheked</span>
         
          <q-toggle size="xl" checked-icon="check" unchecked-icon="clear" class="my-more-fancy-toggle q-mt-xs q-ml-xs-q-inline pl-0" color="primary" v-model="intBRRule.checked"  @update:model-value="onChangeBR($event)"/>
      
        </div>
      
      </div>
    </div>
  </q-form>
  </template>
  
  <script lang="ts">
  import store from "@/store";

  import { Vue } from "vue-class-component";
  
  
  export default class BusinessruleValueForm extends Vue {
  
    

    get briIdex(){
    return store.state.queryBuilderModule.briIndex || 0
  }

  get isEditingBri(){
  return store.state.queryBuilderModule.isEditingBri
  }

  get intBRRule() {
    const businessRuleValue = store.state.ActionModule.selectedbusinessrulevalueconfig.businessRuleValue;
  
  // Vérifier si `businessRuleValue` est null ou non défini
  if (!businessRuleValue || !Array.isArray(businessRuleValue)) {
    store.state.ActionModule.selectedbusinessrulevalueconfig.businessRuleValue = [];
  }

  if (this.isEditingBri) {
    const rule = store.state.ActionModule.selectedbusinessrulevalueconfig.businessRuleValue[this.briIdex];
    
    // Vérifier que `rule` existe avant d’y accéder
    if (rule) {
      rule.checked = this.normalizeBoolean(rule.checked);
      return rule;
    } else {
      return {}; // Retourner un objet vide pour éviter des erreurs
    }
  } else {
    store.state.ActionModule.selectedbusinessrulevalueconfig.businessRuleValue.push({
      checked: true,
      advancedConfigurationToggle: true
    });

    const newRule = store.state.ActionModule.selectedbusinessrulevalueconfig.businessRuleValue[
      store.state.ActionModule.selectedbusinessrulevalueconfig.businessRuleValue.length - 1
    ];

    newRule.checked = this.normalizeBoolean(newRule.checked);

    return newRule;
  }
    }

    normalizeBoolean(value:any ) {
    return value === true || value === "true";
  }

    onChangeBR(event : any ){
      if(store.state.queryBuilderModule.queryBuilder.DOCUMENTBR.briResults.length >0) {
        store.state.queryBuilderModule.queryBuilder.DOCUMENTBR.briResults[this.briIdex].checked=event
      }
      else{
        store.state.queryBuilderModule.queryBuilder.DOCUMENTBR.briResults.push({
            checked: event
        })
      }
  
  }
  }
  </script>
  